
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/positions-in-fashion",
      function () {
        return require("private-next-pages/positions-in-fashion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/positions-in-fashion"])
      });
    }
  